export const MAX_VISIBLE_SKILLS = 5;

// export const SELECT_CATEGORY = "SELECT_CATEGORY";
// export const DESELECT_CATEGORY = "DESELECT_CATEGORY";
export const SHOW_MORE_SKILLS = "SHOW_MORE_SKILLS";
// export const MOVE_CATEGORY = "MOVE_CATEGORY";
